export interface CapturedProgramWindow { window_start: string; window_end: string }

export const publicPreviewWindowKey = (identity: string, programId: string, facilityId: string) =>
  ["classes", "public-preview-window", identity, programId, facilityId] as const;

export function publicPreviewScope(identity: string, programId: string, facilityId: string,
  kind: "sessions" | "options", window?: CapturedProgramWindow): readonly unknown[] {
  return [identity, "classes", programId, facilityId, "public", kind,
    ...(window ? [window.window_start, window.window_end] : [])];
}

export const initialPreviewKey = (scope: readonly unknown[]) => ["program-preview", ...scope, 0, null];
